import React, { useEffect, useRef, useState, useCallback } from 'react';

import { FallingLines, ThreeDots	 } from  'react-loader-spinner'

import 'bootstrap/dist/css/bootstrap.min.css';
import ModalUberu from './ModalUberu';
import FiltersUberu from './FiltersUberu';

import {
  YMap,
  YMapComponentsProvider,
  YMapDefaultSchemeLayer,
  YMapDefaultFeaturesLayer,
  YMapListener,
  YMapFeature,
  YMapCollection,
  YMapControls,
  YMapGeolocationControl,
  YMapZoomControl,
  YMapHint,
  YMapDefaultMarker,
  YMapContainer,
  YMapControlButton,
  YMapCustomClusterer,
  YMapMarker,
} from "ymap3-components";

import IconBasic from './assets/icons/iconReoBasic.svg';
import axios from 'axios';
import qs from 'qs';
import { apiURL, accessTokenMap, uberuWasteTypes, uberuPointTypes, emptyDataPoint, defaultLat, defaultLng, defaultZoom, apiKeyYandex} from "./Constants"
import { Box, Hidden } from '@mui/material';

let diffChangeMap = 0.2;
let zoomMaxCluster = 19;
let zoomOptCluster = 15;
let zoomStep = 3;
let zoomTemp = defaultZoom;


function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

export const  useWindowDimensions = ()=> {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}


export const AppUberu=  (props)=> {
  const [location, setLocation] = useState({ center: [37.95, 55.65], zoom: 7.5 });
  const ymap3Ref = useRef();
  const ymap3Cluster = useRef();
  const { height, width } = useWindowDimensions();
  const[isLoading, setIsLoading] = useState(true);
  const[latValue, setLatValue] = useState(defaultLat);
  const[lngValue, setLngValue] = useState(defaultLng);
  const[latUser, setLatUser] = useState(defaultLat);
  const[lngUser, setLngUser] = useState(defaultLng);
  const[zoomValue, setZoomValue] = useState(defaultZoom);
  const[appIntegrated, setAppIntegrated] = useState(true);
  const[filterData, setFilterData] = useState([]);

  const[wasteTypesUrl, setWasteTypesUrl] = useState([]);
  const[deviceTypesUrl, setDeviceTypesUrl] = useState([]);
  const[activePointData, setActivePointData] = useState([]);
  const [activePointCoorditates, setActivePointCoorditates] = useState([]);
  const[dataPointsTotal, setDataPointsTotal] = useState([]);
  const[dataPoints, setDataPoints] = useState([]);
  const[pointId, setPointId] = useState(null);
  const[filter, setFilter] = useState(false);
  const[search, setSearch] = useState(false);
  const[modalIsOpen, setModalIsOpen] = useState(false);
  const[filterModalIsOpen, setFilterModalIsOpen] = useState(false);
 


  useEffect(() =>{
    const url = new URL(window.location.href);
    const lng = url.searchParams.get('lng'); 
    const lat =url.searchParams.get('lat'); 
    const zoom =url.searchParams.get('zoom'); 
    const wasteTypesSelected =url.searchParams.getAll('wasteTypes'); 
    const deviceTypesSelected =url.searchParams.getAll('deviceTypes');
    const filterEnabled =url.searchParams.get('filter');
    const searchEnabled =url.searchParams.get('search');
    const newApp =url.searchParams.get('newapp');


    if(newApp == null){
      setAppIntegrated(false);
      setFilter(true)
    }

    if(filterEnabled == "false"){
      setFilter(false);
    }

    if(searchEnabled == "true"){
      setSearch(searchEnabled);
    }

    if(deviceTypesSelected.length >0 || wasteTypesSelected.length >0){
      setDeviceTypesUrl(deviceTypesSelected)
      setWasteTypesUrl(wasteTypesSelected)
      var pointTypesSelectedTemp = uberuPointTypes.filter(p =>  deviceTypesSelected.includes(p.Id.toString())).map(p => p.Id)
       var wasteTypesSelectedTemp = uberuWasteTypes.filter(p =>  wasteTypesSelected.includes(p.NameDb) || wasteTypesSelected.includes(p.Name)).map(p => p.Name)
      setFilterData({
        types: pointTypesSelectedTemp,
        wastes: wasteTypesSelectedTemp
      }
      )
      console.log({
        types: pointTypesSelectedTemp,
        wastes: wasteTypesSelectedTemp
      })
    }
  
      getData();

      lng != null && setLngValue(lng);
      lat != null && setLatValue(lat);
      lng != null && setLngUser(lng);
      lat != null && setLatUser(lat);
      zoom != null && setZoomValue(zoom);
      if (zoom != null) zoomTemp = zoom;
  
  }, [])

  const getData = (devices, wastes) =>{
    setIsLoading(true)
    var params = new URLSearchParams();
    // devices.map((i) =>{
    //   params.append("deviceTypes", i);
    // });
    // wastes.map((i) =>{
    //   params.append("wasteTypes", i);
    // });
    // // console.log(devices)
    // // console.log(wastes)
    var mainParams  = params;
    // var filterTemp = {
    //   types: devices,
    //   wastes: wastes
    // };
    // console.log(filterTemp)
    // setFilterData(filterTemp)
    axios({
        method: 'get',
        url: apiURL + 'PointsArray',
        withCredentials: false,
        params: mainParams
    })
    .then(response => {
        setDataPointsTotal(response.data);
        // setDataPoints(response.data);
        setIsLoading(false);
        // updateFilters(filterTemp, response.data)
    })
    .catch((error) => {
        setIsLoading(false);
    });   
  }

  useEffect(() => {
    if(dataPointsTotal != undefined)
    if(dataPointsTotal.length >= 1)
    {
      console.log(filterData)
      updateFilters(filterData)
    }
      
  },[dataPointsTotal])

  const getPointData = (id) => {
      axios({
          method: 'get',
          url: apiURL + 'PointData',
          rejectUnauthorized: false,
          params:{
              id: id
          }
        })
        .then(response => {
          setModalIsOpen(true)
          setActivePointData(response.data)
          //console.log(response.data)
        })
        .catch((error) => {
          setIsLoading(false)
        });
  }

  const callRNPoint = (id) => {
    window.ReactNativeWebView.postMessage('point:' + id);
  }

  const updateFilters = (f) =>{
      console.log(f)
      let data = dataPointsTotal;
      // console.log(data.length)
      if(f.types != undefined)
      if(f.types.length > 0)
      {
        data = data.filter((el) => f.types.includes(el.properties.type))
      }
      if(f.wastes != undefined)
      if(f.wastes.length > 0)
        {
          if (f.wastes.includes("wTetrapak")) data =data.filter((el) => el.properties.wTetrapak == true)
          if (f.wastes.includes("wAluminium"))  data = data.filter((el) => el.properties.wAluminium == true)
          if (f.wastes.includes("wAppliances"))  data =  data.filter((el) => el.properties.wAppliances == true)
          if (f.wastes.includes("wBatteries"))   data =  data.filter((el) => el.properties.wBatteries == true)
          if (f.wastes.includes("wCaps"))   data =  data.filter((el) => el.properties.wCaps == true)
          if (f.wastes.includes("wDangerous"))  data =  data.filter((el) => el.properties.wDangerous == true)
          if (f.wastes.includes("wGlass"))  data =  data.filter((el) => el.properties.wGlass == true)
          if (f.wastes.includes("wLamps"))  data =  data.filter((el) => el.properties.wLamps == true)
          if (f.wastes.includes("wMetall"))  data =  data.filter((el) => el.properties.wMetall == true)
          if (f.wastes.includes("wMetallColoured"))  data =  data.filter((el) => el.properties.wMetallColoured == true)
          if (f.wastes.includes("wPaper")) data =  data.filter((el) => el.properties.wPaper == true)
          if (f.wastes.includes("wPet")) data =  data.filter((el) => el.properties.wPet == true)
          if (f.wastes.includes("wPlastic"))  data =  data.filter((el) => el.properties.wPlastic == true)
          if (f.wastes.includes("wShoes")) data =   data.filter((el) => el.properties.wShoes == true)
          if (f.wastes.includes("wTyres"))  data =  data.filter((el) => el.properties.wTyres == true)
          if (f.wastes.includes("wWear")) data =   data.filter((el) => el.properties.wWear == true)
          if (f.wastes.includes("wMedicine"))  data =   data.filter((el) => el.properties.wMedicine == true)
          if (f.wastes.includes("wOther")) data =   data.filter((el) => el.properties.wOther == true)
        }
      // console.log(f)
      // console.log(dataPointsTotal[1])
      setDataPoints(data)
  }

  const getPoint = (id) =>{
    const url = new URL(window.location.href);
    url.searchParams.get('newapp') != null
    ? callRNPoint(id) 
    : getPointData(id)
  }

  const marker = useCallback(
    (feature) => (
      <YMapMarker coordinates={feature.geometry.coordinates}>
        <Box onClick={() => {setActivePointCoorditates(feature.geometry.coordinates); console.log(feature.geometry.coordinates) ;getPoint(feature.id)}}>
          { feature.properties.wWear == true 
            && feature.properties.wAppliances == false
            && feature.properties.wAluminium == false
            && feature.properties.wBatteries == false
            && feature.properties.wCaps == false
            && feature.properties.wDangerous == false 
            && feature.properties.wGlass == false
            && feature.properties.wLamps == false
            && feature.properties.wMedicine == false
            && feature.properties.wMetall == false 
            && feature.properties.wMetallColoured == false
            && feature.properties.wOther == false
            && feature.properties.wPet == false
            && feature.properties.wPlastic == false 
            && feature.properties.wShoes == false
            && feature.properties.wTetrapak == false 
            && feature.properties.wTyres == false
            && feature.properties.wPaper == false 
          ?
          <svg width="48" height="48" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2413_7546)">
          <path d="M28 14.0001C28 20.6275 22.6274 26.0001 16 26.0001C9.37258 26.0001 4 20.6275 4 14.0001C4 7.3727 9.37258 2.00012 16 2.00012C22.6274 2.00012 28 7.3727 28 14.0001Z" fill="url(#paint0_linear_2413_7546)"/>
          <path d="M14 24.6668H18L17.3333 30.0001C17.3333 30.7365 16.7364 31.3335 16 31.3335C15.2636 31.3335 14.6667 30.7365 14.6667 30.0001L14 24.6668Z" fill="url(#paint1_linear_2413_7546)"/>
          <g clip-path="url(#clip1_2413_7546)">
          <path d="M19.6574 7.64148L19.4573 7.84196V7.64148H18.4716C18.0272 8.32822 17.089 8.80293 15.9996 8.80293C14.9107 8.80293 13.9725 8.32822 13.5281 7.64148H12.5424V7.84196L12.3419 7.64148L8.797 11.1884L10.7361 13.1291L12.5424 11.3219V20.3584H19.4565V11.3223L21.2632 13.1295L23.2019 11.1884L19.6574 7.64148Z" fill="white"/>
          <path d="M19.4566 21.1556H12.5425C12.1024 21.1556 11.7453 20.7985 11.7453 20.3584V13.2471L11.2997 13.6927C11.1502 13.8425 10.9474 13.9262 10.7357 13.9262C10.5245 13.9262 10.3212 13.8421 10.1717 13.6927L8.23268 11.752C7.92179 11.4407 7.92179 10.9365 8.23268 10.6248L11.7784 7.07793C11.9514 6.90455 12.2013 6.82045 12.442 6.85074C12.4751 6.84675 12.5086 6.84436 12.5425 6.84436H13.5281C13.7984 6.84436 14.0507 6.98147 14.1974 7.20826C14.511 7.69293 15.2185 8.00581 15.9997 8.00581C16.7809 8.00581 17.4888 7.69293 17.8025 7.20826C17.9491 6.98147 18.201 6.84436 18.4717 6.84436H19.4573C19.4912 6.84436 19.5247 6.84635 19.5578 6.85074C19.5905 6.84675 19.6236 6.84436 19.657 6.84436C19.8683 6.84436 20.0716 6.92846 20.2214 7.07793L23.7663 10.6244C24.0772 10.9357 24.0772 11.4399 23.7663 11.7516L21.8277 13.6927C21.6782 13.8421 21.4753 13.9262 21.2641 13.9262C21.0528 13.9266 20.8496 13.8425 20.7001 13.6931L20.2541 13.2467V20.3584C20.2537 20.7989 19.897 21.1556 19.4566 21.1556ZM13.3396 19.5613H18.6594V11.3224C18.6594 10.9999 18.8535 10.7093 19.1512 10.5858C19.4494 10.4618 19.7918 10.5304 20.0201 10.7588L21.2629 12.0015L22.0752 11.1884L19.5247 8.63635C19.3976 8.64791 19.2724 8.62798 19.1524 8.57856C19.0691 8.54428 18.9938 8.49645 18.9284 8.43866H18.8599C18.2018 9.16407 17.1472 9.60011 15.9997 9.60011C14.8522 9.60011 13.798 9.16407 13.1395 8.43866H13.071C13.006 8.49645 12.9307 8.54388 12.8474 8.57856C12.7266 8.62838 12.5983 8.64592 12.4743 8.63635L9.92343 11.1888L10.7357 12.0019L11.9781 10.7588C12.2061 10.5304 12.5488 10.4622 12.847 10.5858C13.1451 10.7093 13.3392 10.9999 13.3392 11.3224V19.5613H13.3396Z" fill="white"/>
          </g>
          <g filter="url(#filter0_f_2413_7546)">
          <rect x="13.1777" y="30.7218" width="5.56771" height="0.611654" rx="0.305827" fill="#5E5E5E" fill-opacity="0.5"/>
          </g>
          </g>
          <defs>
          <filter id="filter0_f_2413_7546" x="11.8444" y="29.3885" width="8.23442" height="3.27836" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="0.666667" result="effect1_foregroundBlur_2413_7546"/>
          </filter>
          <linearGradient id="paint0_linear_2413_7546" x1="37.5625" y1="-0.406129" x2="-4.01681" y2="24.6311" gradientUnits="userSpaceOnUse">
          <stop stop-color="#ED7F30"/>
          <stop offset="1" stop-color="#FFD25D"/>
          </linearGradient>
          <linearGradient id="paint1_linear_2413_7546" x1="37.5625" y1="-0.406129" x2="-4.01681" y2="24.6311" gradientUnits="userSpaceOnUse">
          <stop stop-color="#ED7F30"/>
          <stop offset="1" stop-color="#FFD25D"/>
          </linearGradient>
          <clipPath id="clip0_2413_7546">
          <rect width="32" height="32" fill="white" transform="translate(0 0.666748)"/>
          </clipPath>
          <clipPath id="clip1_2413_7546">
          <rect width="16" height="16" fill="white" transform="translate(8 6.00012)"/>
          </clipPath>
          </defs>
          </svg>
          :<>
          {feature.properties.wPaper == true 
            && feature.properties.wAppliances == false
            && feature.properties.wAluminium == false
            && feature.properties.wBatteries == false
            && feature.properties.wCaps == false
            && feature.properties.wDangerous == false 
            && feature.properties.wGlass == false
            && feature.properties.wLamps == false
            && feature.properties.wMedicine == false
            && feature.properties.wMetall == false 
            && feature.properties.wMetallColoured == false
            && feature.properties.wOther == false
            && feature.properties.wPet == false
            && feature.properties.wPlastic == false 
            && feature.properties.wShoes == false
            && feature.properties.wTetrapak == false 
            && feature.properties.wTyres == false
            && feature.properties.wWear == false 
          ?
          <svg width="48" height="48" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M28 13.3333C28 19.9607 22.6274 25.3333 16 25.3333C9.37258 25.3333 4 19.9607 4 13.3333C4 6.7059 9.37258 1.33331 16 1.33331C22.6274 1.33331 28 6.7059 28 13.3333Z" fill="url(#paint0_linear_2389_7486)"/>
            <path d="M14 24H18L17.3333 29.3333C17.3333 30.0697 16.7364 30.6666 16 30.6666C15.2636 30.6666 14.6667 30.0697 14.6667 29.3333L14 24Z" fill="url(#paint1_linear_2389_7486)"/>
            <g filter="url(#filter0_f_2389_7486)">
            <rect x="13.1777" y="30.0551" width="5.56771" height="0.611654" rx="0.305827" fill="#5E5E5E" fill-opacity="0.5"/>
            </g>
            <g clip-path="url(#clip0_2389_7486)">
            <path d="M10.4475 7.2215C10.447 7.2215 10.4465 7.2215 10.4461 7.2215C10.2948 7.2215 10.1525 7.28049 10.045 7.38769C9.93632 7.49608 9.87646 7.64041 9.87646 7.79405V16.3794C9.87646 16.6942 10.1336 16.951 10.4497 16.9518C11.7824 16.955 14.0152 17.2327 15.5555 18.8446V9.85984C15.5555 9.75311 15.5283 9.65286 15.4768 9.5699C14.2126 7.53396 11.7832 7.22462 10.4475 7.2215Z" fill="white"/>
            <path d="M22.1235 16.3794V7.79399C22.1235 7.64035 22.0636 7.49602 21.9549 7.38763C21.8475 7.28043 21.705 7.22144 21.5539 7.22144C21.5534 7.22144 21.5529 7.22144 21.5525 7.22144C20.2168 7.22461 17.7874 7.53395 16.5231 9.56989C16.4717 9.65285 16.4445 9.75311 16.4445 9.85983V18.8446C17.9848 17.2327 20.2176 16.9549 21.5503 16.9517C21.8663 16.9509 22.1235 16.6942 22.1235 16.3794Z" fill="white"/>
            <path d="M23.4276 9.20142H23.0125V16.3794C23.0125 17.1832 22.3575 17.8387 21.5525 17.8407C20.4221 17.8434 18.5582 18.0644 17.2382 19.3138C19.5212 18.7548 21.9278 19.1182 23.2994 19.4307C23.4707 19.4697 23.6477 19.4294 23.7849 19.3201C23.9216 19.211 24 19.0479 24 18.8729V9.77386C24.0001 9.45822 23.7432 9.20142 23.4276 9.20142Z" fill="white"/>
            <path d="M8.98759 16.3794V9.20142H8.57245C8.25686 9.20142 8 9.45822 8 9.77386V18.8727C8 19.0478 8.07844 19.2108 8.21517 19.3199C8.35227 19.4292 8.52908 19.4697 8.70061 19.4306C10.0722 19.1179 12.4789 18.7546 14.7618 19.3136C13.4418 18.0643 11.578 17.8433 10.4476 17.8406C9.64256 17.8387 8.98759 17.1832 8.98759 16.3794Z" fill="white"/>
            </g>
            <defs>
            <filter id="filter0_f_2389_7486" x="11.8444" y="28.7217" width="8.23442" height="3.27836" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
            <feGaussianBlur stdDeviation="0.666667" result="effect1_foregroundBlur_2389_7486"/>
            </filter>
            <linearGradient id="paint0_linear_2389_7486" x1="37.5625" y1="-1.07294" x2="-4.01681" y2="23.9643" gradientUnits="userSpaceOnUse">
            <stop stop-color="#ED7F30"/>
            <stop offset="1" stop-color="#FF7A5D"/>
            </linearGradient>
            <linearGradient id="paint1_linear_2389_7486" x1="37.5625" y1="-1.07294" x2="-4.01681" y2="23.9643" gradientUnits="userSpaceOnUse">
            <stop stop-color="#ED7F30"/>
            <stop offset="1" stop-color="#FF7A5D"/>
            </linearGradient>
            <clipPath id="clip0_2389_7486">
            <rect width="16" height="16" fill="white" transform="translate(8 5.33331)"/>
            </clipPath>
            </defs>
            </svg>  
          :
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M42 20C42 29.9411 33.9411 38 24 38C14.0589 38 6 29.9411 6 20C6 10.0589 14.0589 2 24 2C33.9411 2 42 10.0589 42 20Z" fill="url(#paint0_linear_2192_6977)"/>
          <path d="M21 36H27L26 44C26 45.1046 25.1046 46 24 46C22.8954 46 22 45.1046 22 44L21 36Z" fill="url(#paint1_linear_2192_6977)"/>
          <path fillRule="evenodd" clipRule="evenodd" d="M24.5139 7.64982C24.2037 7.43883 23.796 7.43883 23.4858 7.64982L12.8521 14.8827C12.6019 15.0529 12.4521 15.3358 12.4521 15.6384V29.54C12.4521 30.0448 12.8613 30.454 13.3661 30.454H15.3735V18.9791C15.3735 18.4743 15.7827 18.0651 16.2875 18.0651H31.8263C32.331 18.0651 32.7402 18.4743 32.7402 18.9791V30.454H34.6336C35.1384 30.454 35.5476 30.0448 35.5476 29.54V15.6384C35.5476 15.3358 35.3978 15.0529 35.1476 14.8827L24.5139 7.64982ZM21.5937 20.0285H23.3149V20.7936C23.3149 21.1777 23.6264 21.4892 24.0106 21.4892C24.3948 21.4892 24.7062 21.1777 24.7062 20.7936V20.0285H26.3923C26.7288 20.0285 27.0016 20.3013 27.0016 20.6378V24.1495C27.0016 24.486 26.7288 24.7588 26.3923 24.7588H21.5937C21.2572 24.7588 20.9844 24.486 20.9844 24.1495V20.6378C20.9844 20.3013 21.2572 20.0285 21.5937 20.0285ZM19.9409 25.7237H18.2197C17.8831 25.7237 17.6104 25.9965 17.6104 26.333V29.8447C17.6104 30.1812 17.8831 30.454 18.2197 30.454H23.0182C23.3548 30.454 23.6276 30.1812 23.6276 29.8447V26.333C23.6276 25.9965 23.3548 25.7237 23.0182 25.7237H21.3322V26.4886C21.3322 26.8728 21.0207 27.1843 20.6365 27.1843C20.2524 27.1843 19.9409 26.8728 19.9409 26.4886V25.7237ZM25.1415 25.7237H26.8628V26.4886C26.8628 26.8728 27.1742 27.1843 27.5584 27.1843C27.9426 27.1843 28.254 26.8728 28.254 26.4886V25.7237H29.9401C30.2766 25.7237 30.5494 25.9965 30.5494 26.333V29.8447C30.5494 30.1812 30.2766 30.454 29.9401 30.454H25.1415C24.805 30.454 24.5322 30.1812 24.5322 29.8447V26.333C24.5322 25.9965 24.805 25.7237 25.1415 25.7237Z" fill="white"/>
          <g filter="url(#filter0_f_2192_6977)">
          <rect x="19.7666" y="45.0825" width="8.35156" height="0.91748" rx="0.45874" fill="#5E5E5E" fillOpacity="0.5"/>
          </g>
          <defs>
          <filter id="filter0_f_2192_6977" x="17.7666" y="43.0825" width="12.3516" height="4.91748" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_2192_6977"/>
          </filter>
          <linearGradient id="paint0_linear_2192_6977" x1="56.3437" y1="-1.60938" x2="-6.02522" y2="35.9465" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0083CC"/>
          <stop offset="1" stopColor="#1FB073"/>
          </linearGradient>
          <linearGradient id="paint1_linear_2192_6977" x1="56.3437" y1="-1.60938" x2="-6.02522" y2="35.9465" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0083CC"/>
          <stop offset="1" stopColor="#1FB073"/>
          </linearGradient>
          </defs>
          </svg>}
          </>        
          }
        </Box>
      </YMapMarker>
    ),
    []
  );

 

  const cluster = useCallback(
    (coordinates, features) => (
      <YMapMarker coordinates={coordinates}>
        <span
          onClick={(p) =>{
            zoomTemp = zoomTemp + zoomStep;
            setZoomValue(zoomTemp);
            console.log(zoomValue);  
            //console.log(ymap3Ref.current)
            // ymap3Ref.setZoom(14, { 
            //   smooth: true,
            //   duration: 2000
            // })
            // console.log(zoomValue == zoomOptCluster  ? zoomMaxCluster: zoomOptCluster);
            setLngValue(coordinates[0]);
            setLatValue(coordinates[1])}}
          style={{
            borderRadius: "50%",
            background: "#116062",
            color: "white",
            width: 42,
            height: 42,
            outline: "#116062",
            outlineOffset: "3px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {features.length}
        </span>
      </YMapMarker>
    ),
    []
  );

  return (
    <div style={{height: height,
      width: width, background: "transparent", margin: 0,
      padding: 0}}>
      <YMapComponentsProvider apiKey={apiKeyYandex} lang="ru_RU" >
        <YMap
          ref={ymap3Ref}
          location={{ center: [lngValue, latValue], zoom: zoomValue }}
          mode="vector"
          zoomRange={{min: 5, max: 30}}
        >
            <YMapDefaultSchemeLayer />
            <YMapDefaultFeaturesLayer />
            <YMapListener   
              layer='any' 
              onActionEnd={(p) => {
                setLngValue(p.location.center[0]); 
                setLatValue(p.location.center[1]); 
                setZoomValue(p.location.zoom); 
                zoomTemp = p.location.zoom
              }}/>
            <YMapCustomClusterer
                marker={marker}
                cluster={cluster}
                gridSize={64}
                features={dataPoints}
              />
              {activePointCoorditates[0] != undefined &&
              <YMapMarker coordinates={[activePointCoorditates[0], activePointCoorditates[1]]} zIndex={300}>
                <svg width="48" height="48" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M35 16.6667C35 24.951 28.2843 31.6667 20 31.6667C11.7157 31.6667 5 24.951 5 16.6667C5 8.38242 11.7157 1.66669 20 1.66669C28.2843 1.66669 35 8.38242 35 16.6667Z" fill="#FF9820"/>
                <path d="M17.5 30H22.5L21.6667 36.6667C21.6667 37.5872 20.9205 38.3334 20 38.3334C19.0795 38.3334 18.3333 37.5872 18.3333 36.6667L17.5 30Z" fill="#FF9820"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.4281 6.37485C20.1696 6.19902 19.8299 6.19902 19.5714 6.37485L10.71 12.4022C10.5015 12.5441 10.3767 12.7799 10.3767 13.032V24.6167C10.3767 25.0373 10.7177 25.3783 11.1383 25.3783H12.8113V15.8159C12.8113 15.3953 13.1523 15.0543 13.5729 15.0543H26.5219C26.9425 15.0543 27.2835 15.3953 27.2835 15.8159V25.3783H28.8613C29.2819 25.3783 29.6229 25.0373 29.6229 24.6167V13.032C29.6229 12.7799 29.4981 12.5441 29.2896 12.4022L20.4281 6.37485ZM17.9947 16.6904H19.429V17.328C19.429 17.6481 19.6886 17.9077 20.0087 17.9077C20.3289 17.9077 20.5884 17.6481 20.5884 17.328V16.6904H21.9936C22.274 16.6904 22.5013 16.9177 22.5013 17.1982V20.1246C22.5013 20.405 22.274 20.6323 21.9936 20.6323H17.9947C17.7143 20.6323 17.487 20.405 17.487 20.1246V17.1982C17.487 16.9177 17.7143 16.6904 17.9947 16.6904ZM16.6174 21.4364H15.1831C14.9026 21.4364 14.6753 21.6637 14.6753 21.9441V24.8705C14.6753 25.151 14.9026 25.3783 15.1831 25.3783H19.1819C19.4623 25.3783 19.6896 25.151 19.6896 24.8705V21.9441C19.6896 21.6637 19.4623 21.4364 19.1819 21.4364H17.7768V22.0739C17.7768 22.394 17.5173 22.6536 17.1971 22.6536C16.877 22.6536 16.6174 22.394 16.6174 22.0739V21.4364ZM20.9513 21.4364H22.3856V22.0739C22.3856 22.394 22.6451 22.6536 22.9653 22.6536C23.2854 22.6536 23.545 22.394 23.545 22.0739V21.4364H24.9501C25.2305 21.4364 25.4579 21.6637 25.4579 21.9441V24.8705C25.4579 25.151 25.2305 25.3783 24.9501 25.3783H20.9513C20.6709 25.3783 20.4435 25.151 20.4435 24.8705V21.9441C20.4435 21.6637 20.6709 21.4364 20.9513 21.4364Z" fill="white"/>
                <g filter="url(#filter0_f_890_6777)">
                <rect x="16.4722" y="37.5687" width="6.95964" height="0.764567" rx="0.382284" fill="#5E5E5E" fill-opacity="0.5"/>
                </g>
                <defs>
                <filter id="filter0_f_890_6777" x="14.8055" y="35.9021" width="10.2931" height="4.09786" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="0.833333" result="effect1_foregroundBlur_890_6777"/>
                </filter>
                </defs>
                </svg>
              </YMapMarker>}

              {latUser !=  defaultLat &&
              <YMapMarker coordinates={[lngUser, latUser]} zIndex={400}>
                  <svg width="48" height="48" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g filter="url(#filter0_f_393_5372)">
                  <rect x="13.1777" y="30.0551" width="5.56772" height="0.611655" rx="0.305827" fill="#5E5E5E" fill-opacity="0.5"/>
                  </g>
                  <path d="M28 13.3334C28 19.9608 22.6275 25.3334 16 25.3334C9.37259 25.3334 4 19.9608 4 13.3334C4 6.70597 9.37259 1.33337 16 1.33337C22.6275 1.33337 28 6.70597 28 13.3334Z" fill="#FF9820"/>
                  <path d="M14 24.0001H18L17.3334 29.3334C17.3334 30.0698 16.7364 30.6668 16 30.6668C15.2636 30.6668 14.6667 30.0698 14.6667 29.3334L14 24.0001Z" fill="#FF9820"/>
                  <circle cx="16.0001" cy="13.1116" r="4.95484" fill="white"/>
                  <defs>
                  <filter id="filter0_f_393_5372" x="11.8444" y="28.7217" width="8.23442" height="3.27837" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                  <feGaussianBlur stdDeviation="0.666668" result="effect1_foregroundBlur_393_5372"/>
                  </filter>
                  </defs>
                  </svg>
              </YMapMarker>}

        </YMap>
       
      </YMapComponentsProvider>
      <FiltersUberu
            hidden={!filter}
            initialWasteTypes={wasteTypesUrl}
            initialPointTypes={deviceTypesUrl}
            show={filterModalIsOpen}
            onOpen={() => {setModalIsOpen(false); setFilterModalIsOpen(true)}}
            onUpdate={(res) => {updateFilters(res); console.log(res);  setFilterData(res)}}
            onHide={() => setFilterModalIsOpen(false)}
        /> 
        {modalIsOpen
          && <ModalUberu
              show={modalIsOpen}
              data={activePointData}
              onOpen={() => setFilterModalIsOpen(false)}
              onHide={() => {setModalIsOpen(false); setActivePointData([])}}
          />} 
        {isLoading 
              &&
              <div className='loader-container'>
                <div className='inner'>
                    <ThreeDots
                        color = '#0d90ae'
                    />
                </div>
              </div>
        }
     </div>
    )
  }

export default AppUberu;